import { Helmet } from "react-helmet";

const TravelAgencySchema = () => {

const schema = {
"@context":"https://schema.org",
"@type":"TravelAgency",
"name":"Amruta Travels",
"url":"https://bushireinpune.com",
"logo":"https://bushireinpune.com/logo192.png",
"telephone":"+91 7353109555",
"email":"booking@bushireinpune.com",
"address":{
"@type":"PostalAddress",
"streetAddress":"Office No.-2, Ground Floor, Wings H-(Puram), Prayeja City Phase-2, Vadgaon Budruk",
"addressLocality":"Pune",
"addressRegion":"Maharashtra",
"postalCode":"411041",
"addressCountry":"IN"
},
"areaServed":{
"@type":"City",
"name":"Pune"
},
"sameAs":[
"https://www.facebook.com/",
"https://www.instagram.com/"
]
};

return(
<Helmet>
<script type="application/ld+json">
{JSON.stringify(schema)}
</script>
</Helmet>
);

};

export default TravelAgencySchema;